import { useInboxUnreadSummary } from '~/features/whatsapp/hooks/useInboxUnreadSummary';
import { useResolvedChatEntryState } from '~/features/whatsapp/hooks/useResolvedChatEntryState';
import { type ChatEntryState } from '~/features/whatsapp/utils/resolveChatEntryState';

// any visible chat keeps the entry enabled without a number
export const useChatEntryState = (): ChatEntryState => {
    const { data: summary, error: summaryError, isPending: isSummaryPending } = useInboxUnreadSummary();

    const hasExistingChats = (() => {
        if (isSummaryPending) return undefined;
        if (!summary) return null;
        // zero-count entries included, so a non-empty summary means visible chats exist
        return summary.byLoanRequest.length + summary.partner.length + summary.unlinked.length > 0;
    })();

    return useResolvedChatEntryState(hasExistingChats, summaryError);
};
